// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"96518cd0","453":"161787b6","527":"6e24d8bc"}[chunkId] + ".chunk.js";
};